import styles from './users-without-company.module.scss';
import { useGetRequestNewHook } from '../requestUtils';
import { CreateHeaders, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface UsersWithoutCompanyProps { }

export function UsersWithoutCompany(props: UsersWithoutCompanyProps) {
  const { t } = useTranslation();
  const { data } = useGetRequestNewHook(`admin/foreignCompanyRequests`, []);
  return (
    <WebkuaTable
      headers={CreateHeaders([
        textHeader("companyName", t("standard.company"), HeaderSizeEnum.SMALL),
        textHeader("email", t("standard.email"), HeaderSizeEnum.SMALL),
        textHeader("firstName", t("standard.firstName"), HeaderSizeEnum.SMALL),
        textHeader("lastName", t("standard.lastName"), HeaderSizeEnum.SMALL),
        textHeader("phoneNumber", t("standard.phone"), HeaderSizeEnum.SMALL),
        textHeader("address", t("standard.address")),
        textHeader("country", t("usersWithoutCompany.country")),
        textHeader("orgNr", t("standard.organisationNumber"))
      ])}
      data={data}
    />
  );
}

export default UsersWithoutCompany;